import { useState } from 'react';
import { ethers } from 'ethers';

export const useWallet = () => {
  const [account, setAccount] = useState('');
  const [balance, setBalance] = useState('0');
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);

  const handleWalletConnect = async () => {
    if (window.ethereum) {
      try {
        const browserProvider = new ethers.BrowserProvider(window.ethereum);
        setProvider(browserProvider);
        
        const accounts = await browserProvider.send("eth_requestAccounts", []);
        const selectedAccount = accounts[0];
        setAccount(selectedAccount);

        const balanceInWei = await browserProvider.getBalance(selectedAccount);
        const balanceInEth = ethers.formatEther(balanceInWei);
        setBalance(balanceInEth);

        const signer = await browserProvider.getSigner();
        setSigner(signer);

        console.log("Connected wallet address:", selectedAccount);
        console.log("Wallet balance:", balanceInEth);

        return { provider: browserProvider, signer, account: selectedAccount };
      } catch (error) {
        console.log("Error with connection: ", error);
        throw error;
      }
    } else {
      throw new Error("Ethereum provider not found. Please install MetaMask.");
    }
  };

  return {
    account,
    balance,
    provider,
    signer,
    handleWalletConnect,
    setAccount,
    setBalance
  };
};